import { useState, useEffect } from 'react';
import { getNftRedemptions } from '../services';
import { NftRedemptionModel } from '../models';

const COLLECTION_ID = '0576f4c5-6acb-4aff-a8ac-b3f4bb2002c5';

export const useNftRedemptions = () => {
   const [nftRedemptions, setNftRedemptions] = useState<NftRedemptionModel[]>([]);
   const [loading, setLoading] = useState(true);
   const [error, setError] = useState<string | null>(null);

   useEffect(() => {
      const fetchNftRedemptions = async () => {
         try {
            setLoading(true);
            setError(null);
            const response = await getNftRedemptions(COLLECTION_ID);

            if (response.error) {
               setError(response.error.message);
            } else {
               setNftRedemptions(response.data || []);
            }
         } catch (err) {
            setError('Failed to fetch NFT redemptions');
            console.error('Error fetching NFT redemptions:', err);
         } finally {
            setLoading(false);
         }
      };

      fetchNftRedemptions();
   }, []);

   return { nftRedemptions, loading, error };
};
